import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20warm%20gradient%20shapes%20in%20coral%20and%20dark%20charcoal%20tones%2C%20soft%20geometric%20overlay%2C%20modern%20minimal%20design%2C%20elegant%20atmospheric%20background%2C%20smooth%20curves%2C%20cinematic%20lighting%2C%20high%20detail%2C%20harmonious%20composition&width=1800&height=600&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-white font-[var(--font-heading)] mb-4">
          立刻访问禁漫天堂
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          收藏本站获取禁漫天堂最新入口地址和使用教程，确保随时畅享丰富漫画内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/guide"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            查看使用教程
          </Link>
          <Link
            to="/article/latest-access-url"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            获取最新入口
          </Link>
        </div>
      </div>
    </section>
  );
}